/**
 * @desc: -  日工资 团队管理 注册弹出框
 * @author: danny
 */

import {DateGroup,RangeGroup,SearchGroup,Pagintaion,Bread} from "../ReportComponent.jsx";
import React from 'react';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as baseAction from '../../../../actions/baseAction'
import * as userAction from '../../../../actions/userAction'
import * as commonAction from "../../../../actions/commonAction";
import * as reportAction from "../../../../actions/reportAction";

import ReportBase from '../ReportBase.jsx'
import Popup from "../../../../components/modal/popup.jsx";
class LotteryBetRecord extends ReportBase{
	constructor(props){
		super(props)
	}
	refer(){

	}
	
	breadRefer(){
	}
	
	render(){
		const __base = this.props.__BASE.toJS();
		const __report = this.props.__REPORT.toJS();
		
		if(!__report.current_view ) return <div></div>
		const {searchValue,orderBy,sort} = this.state;
		
		
		return (
      <div className="report-commer-container popup-small-container">
        <div className="register-container">
          <div className="pop-title-warp">
            <h6 className="title">注册开户</h6>
          </div>

          <div className="name-warp">
            <span>用户名：</span>
            <input />

            <p className="reminder">用户名不可用</p>
          </div>

          <div className="pwd-warp">
            <span>密码：</span>
            <input type="password" />
            <p className="reminder">由字母和数字组成6-16个字符，且必须包含数字和字母</p>
          </div>

          <div className="feedback-warp">
            <span className="fbset">返点设置：</span>
            <RangeGroup
              title=""
              rangeMenuInfo={[
                { title: "5.6", optionValue: 5.6 },
                { title: "5.7", optionValue: 5.7 },
              ]}
              rangeMenuClick={this.rangeMenuClick}
            />
            <span className="code">%</span>
            <span className="selffb">自身返点：6.0%</span>
          </div>

          <div className="botton-warp">
            <span className="blue-botton">reset</span>
            <span className="blue-botton">确定</span>
          </div>
        </div>
      </div>
    );
	}
}

reactMixin(LotteryBetRecord.prototype, ImmutableMixin);

function mapStateToProps(state) {
	return {
		__BASE: state.base,
		__USER: state.user,
		__REPORT:state.report
	}
}

function mapDispatchToProps(dispatch) {
	return {
		$$USER: bindActionCreators(userAction, dispatch),
		$$COMMON: bindActionCreators(commonAction, dispatch),
		$$BASE: bindActionCreators(baseAction, dispatch),
		$$REPORT:bindActionCreators(reportAction, dispatch),
	}
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(LotteryBetRecord)
